export default {"src":"/_next/static/media/Mini-menu-white.23910995.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};